import createRequestBody from '../../utils/createRequestBody';

const sendAnalytics = async(url, token, eventData) => {

    eventData.payload=eventData.payload || {}
    
    // eventData.payload.timing=new Date().toTimeString()
    // console.log(eventData)

    let body = createRequestBody('POST', token, eventData);

    return fetch(url, body);

}

export default sendAnalytics;